import { useEffect, useState } from "react";
import { api } from "./api";
import { SignIn } from "./SignIn";
import { DeskQueue } from "./DeskQueue";

export function App() {
  const [auth, setAuth] = useState<"loading" | "in" | "out">("loading");

  useEffect(() => {
    api
      .me()
      .then((r) => setAuth(r.authenticated ? "in" : "out"))
      .catch(() => setAuth("out"));
  }, []);

  if (auth === "loading") {
    return (
      <div className="flex min-h-dvh items-center justify-center text-sm text-[color:var(--color-ink-soft)]">
        <span className="animate-pulse-soft">Checking session…</span>
      </div>
    );
  }

  if (auth === "out") {
    return <SignIn onSignedIn={() => setAuth("in")} />;
  }

  return <DeskQueue onLogout={() => setAuth("out")} />;
}
